module.exports = __webpack_public_path__ + "static/img/whoapp.439ae138.png";